// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__w5sXF"};